import { isSatisfyOption } from 'shared/lib/isSatisfyOption';
import type { TOffer } from 'shared/types/TRankingService';

export const getAnalyticFromSummaries = (summaries: TOffer['summaries']) => {
  const amountItem = summaries.find(({ type }) => type === 'LoanAmount');
  const termItem = summaries.find(({ type }) => type === 'LoanTerm');
  const additionalItem = summaries.find(({ type }) => !isSatisfyOption(['LoanAmount', 'LoanTerm'], type));

  return {
    amount: String(amountItem?.value || ''),
    term: String(termItem?.value || ''),
    additionalName: String(additionalItem?.label || ''),
    additionalValue: String(additionalItem?.value || ''),
  };
};
